import React, { useMemo, useCallback, useRef } from "react";
import { Box, Paper, ToggleButtonGroup, ToggleButton } from "@mui/material";
import MarkerFullGraySVG from "../../image/balloon icons-08.png";
import MarketDisabledSVG from "../../image/balloon_full_gray_64x64-21.svg";

import { MHidden } from "../@material-extend";
import { StyledImg } from "../common/Styled";
import { vehicleSegmentList } from "../../util/Display";

const styles = {
  formControlLabel: {
    "&:first-child": {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  viewMobileIconCheckbox: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    left: 16,
    bottom: "calc(48px + 242px)",
    borderRadius: "50px",
    width: "initial",
    minWidth: "48px",
  },
  toggleButtonGroup: {
    height: "48px",
    "& > button:first-child": {
      "border-top-left-radius": "50px",
      "border-bottom-left-radius": "50px",
    },
    "& > button:last-child": {
      "border-top-right-radius": "50px",
      "border-bottom-right-radius": "50px",
    },
  },
  segmentPaper: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  segmentImage: {
    marginLeft: "8px",
  },
};

function VehicleSegment({ onFilter, data }) {
  const segments = useMemo(() => vehicleSegmentList, []);
  const segmentsChecked = useMemo(
    () => segments.map((segment) => data[segment.name] && segment.name),
    [data]
  );
  const onFilterChanged = useCallback(
    (e) => {
      const _json = JSON.parse(e.currentTarget.dataset.json);
      e.target.checked = !data[_json.name];
      onFilter(_json.name, _json.id, e);
    },
    [data]
  );

  return (
    <MHidden width="lgDown">
      <Box className="vehicle-segment">
          <Paper
            sx={styles.segmentPaper}
            component="div"
            className="relative Map-action-button"
          >
            <ToggleButtonGroup
              sx={styles.toggleButtonGroup}
              onChange={onFilterChanged}
              value={segmentsChecked}
              color="primary"
            >
              {segments.map((segment) => (
                <ToggleButton
                  value={segment.name}
                  key={segment.id}
                  data-json={JSON.stringify({
                    id: segment.id,
                    name: segment.name,
                  })}
                >
                  <Box>
                    <StyledImg
                      src={
                        data[segment.name] ? segment.marker : MarketDisabledSVG
                      }
                      alt={segment.ariaLabel}
                      width={data[segment.name] ? 18 : 28}
                    />
                    <StyledImg
                      src={data[segment.name] ? segment.src : segment.disableSrc}
                      alt={segment.ariaLabel}
                      width={38}
                      style={styles.segmentImage}
                    />
                  </Box>
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Paper>
      </Box>
    </MHidden>
  );
}

export default VehicleSegment;
